import styled from 'styled-components';

export const OperationsTableHeader = styled.div`
    display: grid;
    grid-template-columns: 0.15fr 3fr 1fr 1fr 1fr 1fr 1.25fr;
    background-color: #e6e6e6;
    border-bottom: 1px solid #e0e0e0;
    font-weight: 600;
`;

export const OperationsTableRow = styled.div`
    display: grid;
    grid-template-columns: 0.15fr 3fr 1fr 1fr 1fr 1fr 1.25fr;
    border-bottom: 1px solid #e0e0e0;
    &:last-child {
        border-bottom: none;
    }
    &:nth-child(odd) {
        background-color: #ffffff;
    }
    padding: 10px;
`;

export const OperationsTable = styled.div`
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    overflow: hidden;
    margin: 10px 0;
`;

export const OperationsTableHeaderCell = styled.div`
    text-align: center;
    padding: 5px;
    &:first-child,
    &:nth-child(2) {
        text-align: left;
    }
`;

export const OperationsTableCell = styled.div`
    text-align: center;
    padding: 5px;
    &:first-child,
    &:nth-child(2) {
        text-align: left;
    }
    &.warning {
        background: ${(props) => props.theme.colors.background.warning};
    }

    .port-berth-container {
        display: flex;
        flex-direction: column;
        gap: 4px;

        .berth-only {
            padding-left: 16px;
        }
    }
`;

export const StowageItemCell = styled(OperationsTableCell)`
    padding-left: 32px;
    font-size: 0.9em;
    color: #666;
`;

export const StowageItemDataCell = styled(OperationsTableCell)`
    font-size: 0.9em;
    color: #666;
`;

export const NoStowageItemsCell = styled(OperationsTableCell)`
    font-style: italic;
    color: #666;
    padding: 8px 16px;
`;

export const CargoOverviewDetails = styled.div`
    display: flex;
    flex-direction: column;
`;

export const CargoDetailItem = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 8px;
`;

export const CargoDetailLabel = styled.span`
    font-weight: 500;
    color: ${(props) => props.theme.colors.text};
    margin-right: 8px;
    min-width: 150px;
`;

export const CargoDetailValue = styled.span`
    color: ${(props) => props.theme.colors.textSecondary};
`;

export const NoOperationsMessage = styled.div`
    padding: 12px;
    color: ${(props) => props.theme.colors.textSecondary};
    font-style: italic;
`;

export const OptionsBar = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 16px;
    gap: 10px;
`;

export const CheckboxLabel = styled.label`
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
    font-size: 14px;
`;

export const StyledCheckbox = styled.input`
    margin-right: 8px;
    cursor: pointer;
`;

export const CargoOverviewContent = styled.div<{ isExpanded: boolean }>`
    max-height: ${(props) => (props.isExpanded ? '500px' : '0')};
    overflow: hidden;
    transition: max-height 0.3s ease;
    margin-top: ${(props) => (props.isExpanded ? '12px' : '0')};
`;

export const OperationsTableSectionHeader = styled.div`
    grid-column: 1 / -1;
    padding: 8px 10px;
    font-weight: 600;
    color: ${(props) => props.theme.colors.primary};
    border-bottom: 1px solid #d0d0d0;
    text-align: left;
`;

export const PortLink = styled.a<{ isTransit?: boolean }>`
    cursor: pointer;
    color: #0066cc;
    text-decoration: underline;
    font-weight: ${(props) => (props.isTransit ? 'normal' : '600')};
    font-style: ${(props) => (props.isTransit ? 'italic' : 'normal')};

    &:hover {
        color: #004499;
    }
`;

export const BerthLink = styled.a`
    cursor: pointer;
    color: #0066cc;
    text-decoration: underline;
    font-size: 0.9em;

    &:hover {
        color: #004499;
    }
`;
